<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zChUVC/tc-custom/9780823263400.jpg?1734323334332" alt="This image is the cover for the book After Fukushima"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">After Fukushima
      </h1>
      <p class="bookDescription body article font2">
        <b>The renowned philosopher offers “a powerful reflection on our times . . . and the fate of our civilization, as revealed by the catastrophe of Fukushima” (François Raffoul, <i>Louisiana State University</i>).</b><br/>  <br/> In 2011, a tsunami flooded Japan’s Fukushima Daiichi Nuclear Power Plant, causing three nuclear meltdowns, the effects of which will spread through generations and have an impact on all living things. In <i>After Fukushima</i>, philosopher Jean-Luc Nancy examines the nature of catastrophes in the era of globalization and technology. He argues that in today’s interconnected world, the effects of any disaster will spread in the way we currently associate only with nuclear risk.<br/>  <br/> Can a catastrophe be an isolated occurrence? Is there such a thing as a “natural” catastrophe when all of our technologies—nuclear energy, power supply, water supply—are necessarily implicated, drawing together the biological, social, economic, and political? In this provocative and engaging work, Nancy examines these questions and more.<br/>  <br/> Exclusive to this English edition are two interviews with Nancy conducted by Danielle Cohen-Levinas and Yuji Nishiyama and Yotetsu Tonaki.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jean-Luc Nancy, Charlotte Mandell, Danielle Cohen-Levinas, Yuji Nishiyama, Yotetsu Tonaki
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Fordham University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?44b52580